import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnChanges,
  OnInit,
  signal
} from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { CourseService } from 'src/app/course/services/course.service';
import { ColorSchemeService } from 'src/app/services/color-scheme.service';
import { ButtonComponent } from '../buttons/button/button.component';
import { IconModule } from '../icon/icon.module';
import { Router } from '@angular/router';
import { CheckoutModalService } from 'src/app/course/services/checkout-modal.service';

@Component({
  selector: 'app-purchase-course-banner',
  templateUrl: './purchase-course-banner.component.html',
  styleUrls: ['./purchase-course-banner.component.scss'],
  standalone: true,
  imports: [IconModule, ButtonComponent, UpperCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PurchaseCourseBannerComponent implements OnInit, OnChanges {
  colorSchemeService = inject(ColorSchemeService);
  courseService = inject(CourseService);
  router = inject(Router);
  private checkoutModalService = inject(CheckoutModalService);

  course = input<any>();
  user = input<any>();

  showBanner = signal(true);
  coursePrice = signal('');

  buyLinkText = computed(() => {
    if (this.course() && this.course().buyLinkText && this.course().buyLinkText != '') {
      return this.course().buyLinkText === 'Purchase'
        ? 'Purchase Course'
        : this.course().buyLinkText;
    }

    return 'Purchase Course';
  });

  coursePriceError = false;

  ngOnInit(): void {
    this.showBanner.set(
      !this.user() ||
        (this.user().coursePermissions[this.course().webAppId] != true &&
          this.course().webAppId !== 'GETTING_STARTED' &&
          this.course().webAppId !== 'FLIGHTSIM')
    );

    this.coursePriceError = false;
    this.getCoursePrice()
      .then((val) => {
        this.coursePrice.set(
          '$' + (val.discountPrice !== null ? val.discountPrice : val.price)
        );
      })
      .catch((error) => {
        console.log('Error fetching course price:', error);
        this.coursePriceError = true;
        this.coursePrice.set(this.course().price || '');
      });
  }

  ngOnChanges(): void {
    this.showBanner.set(
      !this.user() ||
        (this.user().coursePermissions[this.course().webAppId] != true &&
          this.course().webAppId !== 'GETTING_STARTED' &&
          this.course().webAppId !== 'FLIGHTSIM')
    );
  }

  getSalesLanguage() {
    return this.course().webAppId === 'PRIVATE' ||
      this.course().webAppId === 'SPORT' ||
      this.course().webAppId === 'RECREATIONAL' ||
      this.course().webAppId === 'COMMERCIAL' ||
      this.course().webAppId === 'INSTRUMENT'
      ? 'Lifetime Access'
      : 'Unlock Course';
  }

  getCoursePrice(): any {
    return this.courseService.getCoursePrice(this.course().webAppId);
  }

  onBuyClick(): void {
    if (!this.course().inCoursePurchaseEnabled) {
      window.open(this.course().webPurchaseUrl, '_blank');
      return;
    }

    this.checkoutModalService.buyCourse(this.course());
  }
}
